import { buildLineStringFromSegments, parseLineString } from '@/services/lineStringService'
import { shouldHideAscentForTour, shouldHideAscentForTrack } from '@/services/tourTypeService'
import {
  calculateTrackDistance,
  getTrackElevationGain,
} from '@/services/trackMetricsCalculationService'
import type { Tour } from '@/types/tour'
import { getBestTrackLineString } from '@/utils/trackGeometry'

export function getTrackCoordinates(track: Tour['tracks'][number]): number[][] {
  const lineString =
    buildLineStringFromSegments(track.segments ?? []) ?? getBestTrackLineString(track)
  return lineString ? parseLineString(lineString) : []
}

export function getTourDistanceMeters(tour: Tour): number {
  return tour.tracks.reduce((sum, track) => sum + calculateTrackDistance(track), 0)
}

export function getTourElevationGainMeters(tour: Tour): number | null {
  if (shouldHideAscentForTour(tour)) return null

  let total: number | null = null
  tour.tracks.forEach((track) => {
    if (shouldHideAscentForTrack(track, tour.type)) return
    const gain = getTrackElevationGain(track)
    if (gain !== null && gain !== undefined) total = (total || 0) + gain
  })
  return total
}

export function formatKm(distanceMeters: number): string {
  return (distanceMeters / 1000).toFixed(1)
}
